<template>
  <div>
    <tabs @TabChange="onTabChange" centered type="neutral" position="bottom" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space ">
      <!-- VC -->
      <tab-pane label="video-call">
        <template slot="label">
          <i class="fa fa-video" />
        </template>
        <div style="
                width: 100%;
                top: 0px;
                bottom: 0px;
                inset-inline-end: 0px;
                height: 100%;
                z-index: 1030;
                background-color: #f1f1f1;
              ">
          <vmaatu :query="simpleMeetingsQuery" v-if="
                  user.endpoint &&
                  user.endpoint.videoConfEPType == 'VMAATU_RTC' &&
                  simpleMeetingsQuery
                " ref="vmaatu"></vmaatu>

          <webex-teams v-if="
                  user.endpoint &&
                  user.endpoint.videoConfEPType == 'WEBEXTEAMS_GUEST'
                " :query="simpleMeetingsQuery" ref="webex-teams"></webex-teams>
          <n-button icon size="lg" style="
                    position: fixed;
                    top: -10px;
                    inset-inline-end: 0px;
                    z-index: 1031;
                    background-color: transparent;
                  " @click.native="leaveAppointment()" class="d-md-none">
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </n-button>
        </div>
      </tab-pane>

      <!-- Patient Details -->
      <tab-pane>
        <template slot="label">
          <i class="fa fa-user" />
        </template>
        <div>
          <div class="row mt-3" v-if="patientDetails">
            <div class="col-12 text-center">
              <profile-image :file-id="patientDetails.profileImage" image-style="width: 100px; height: 100px; border-radius: 50%">
              </profile-image>
            </div>
            <div class="col-12 text-center mt-3">
              {{ patientDetails.patientId }}
              <h6 class="mt-2">
                {{ patientDetails.firstName }} {{ patientDetails.lastName }}
              </h6>
              {{ patientAge }}
              <br />
              <div style="font-size: 30px">
                <span v-if="patientDetails.gender == 'male'" style="color: rgb(33, 150, 243)">
                  <i class="fa fa-mars"></i>
                </span>
                <span v-if="patientDetails.gender == 'female'" style="color: rgb(235, 63, 157)">
                  <i class="fa fa-venus"></i>
                </span>
                <span v-if="patientDetails.gender == 'others'" style="color: rgb(33, 243, 208)">
                  <i class="fa fa-transgender-alt"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Appointment details -->
        <div class="col-12">
          <h5>{{$t('message.Appointment Details')}} </h5>
          <fg-input>
            <textarea :placeholder="$t('message.Reason')" v-model="appointment.reason" :disabled="APPT_PROCESSED"></textarea>
          </fg-input>
          <el-select class="select-primary form-group" size="large" :placeholder="$t('message.Select priority')" v-model="appointment.priority" style="width: 100%" :disabled="APPT_PROCESSED">
            <el-option class="select-primary" value="low" label="Low"></el-option>
            <el-option class="select-primary" value="med" label="Med"></el-option>
            <el-option class="select-primary" value="high" label="High"></el-option>
          </el-select>
          <!-- Doctor search -->
          <cool-select class="custom-input" :placeholder="$t('message.Search Doctor')" :items="filteredDoctorList" ref="select" disable-filtering-by-search @select="selectDoctor" @search="searchDoctor" item-text="firstName" v-if="!appointment.provider" :disabled="APPT_PROCESSED">
            <template slot="item" slot-scope="{ item }">
              <div style="align-items: center; background-color: #f5f5f5;" class="cool-select-results">
                <div class="row">
                  <div class="col-11 autocomplete-result" style="padding-bottom: 10px">
                    <span class="item-name">{{ $t("message.Dr") }}. {{ item.firstName }}
                      {{ item.lastName }}</span>
                    <br />
                    <div style="line-height: 1px; font-size: smaller">
                      {{ item.specialityText }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="no-data">
              <div v-show="doctorSearchText"> {{ $t("message.No doctors found") }}</div>
            </template>
          </cool-select>
          <n-button type="primary" simple style="position: relative; border-radius: 30px; width: 100%" class="text-left custom-input" v-if="appointment.provider">
            {{ $t("message.Dr") }}.
            {{ appointment.provider.firstName }}
            {{ appointment.provider.lastName }}
            <n-button round icon style="position: absolute; inset-inline-end: 0px; top: 0px; margin: 0px;" simple @click.native="appointment.provider = null" :disabled="APPT_PROCESSED">
              <i class="now-ui-icons ui-1_simple-remove"></i>
            </n-button>
          </n-button>
          <div class="row pb-2">
            <div class="col-12 text-center">{{ $t("message.OR") }} </div>
          </div>
          <!-- Speciality search -->
          <cool-select class="custom-input" :placeholder="$t('message.Search speciality')" :items="searchedSpecialities" ref="select" disable-filtering-by-search @select="selectSpeciality" @search="searchSpecialities" item-text="firstName" v-if="!selectedSpeciality" :disabled="APPT_PROCESSED">
            <template slot="item" slot-scope="{ item }">
              <div style="align-items: center" class="cool-select-results">
                <div class="row">
                  <div class="col-11 autocomplete-result" style="padding-bottom: 10px">
                    <span class="item-name">{{ item.name }}</span>
                    <br />
                    <div style="line-height: 1px; font-size: smaller">
                      {{ item.speciality }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="no-data">
              <div v-show="doctorSearchText">{{ $t("message.No doctors found") }}</div>
            </template>
          </cool-select>
          <n-button type="primary" simple style="position: relative; border-radius: 30px; width: 100%" class="text-left custom-input" v-if="selectedSpeciality">
            {{ selectedSpeciality.name }}
            <n-button round icon style="position: absolute; inset-inline-end: 0px; top: 0px; margin: 0px" simple @click.native="selectedSpeciality = null" :disabled="APPT_PROCESSED">
              <i class="now-ui-icons ui-1_simple-remove"></i>
            </n-button>
          </n-button>
          <n-button type="primary" v-if="!APPT_PROCESSED" round @click.native="assign()">{{ $t("message.Assign") }}</n-button>
          <n-button type="primary" v-if="!APPT_PROCESSED" round @click.native="openScheduler()" class="pull-right">{{ $t("message.Schedule") }}</n-button>
        </div>
      </tab-pane>
    </tabs>

    <!-- Appointment scheduler modal-->
    <modal :show.sync="SHOW_SCHEDULER" headerclasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t("message.Select Slot") }}</h4>

      <div v-if="appointment.provider && slots">
        <div class="col-12 p-0" style="border-bottom: 1px solid #0000001f">
          <div class="row">
            <div class="col-3 col-lg-1 text-center">
              <n-button type="primary" round icon @click.native="getSlotsForPreviousDay()" :disabled="days.indexOf(selectedDay) == 0">
                <i class="fa fa-chevron-left"></i>
              </n-button>
            </div>
            <div class="col-6 col-lg-10 text-center" style="white-space: nowrap; overflow: scroll" ref="day-selector">
              <span :id="day.date.getTime()" v-for="day in days" :key="day.date.getTime()" class="ml-3 mr-3 pb-1" @click="selectDay(day)" style="line-height: 65px; cursor: pointer" :style="
                  selectedDay == day
                    ? { borderBottom: '3px solid var(--color-primary)', fontWeight: 'bold' }
                    : {}
                ">{{ getDay(day) }}</span>
            </div>
            <div class="col-3 col-lg-1 text-center">
              <n-button type="primary" round icon @click.native="getSlotsForNextDay()" :disabled="days.indexOf(selectedDay) == days.length - 1">
                <i class="fa fa-chevron-right"></i>
              </n-button>
            </div>
          </div>
        </div>
        <div class="col-sm-12" id="slots-container">
          <div style="display: block">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group providers-slots" style="clear: both" v-show="slots.length > 0" :id="appointment.provider.providerId">
                  <div v-loading="LOADING_SLOTS">
                    <div id="slots-container" v-if="slots.length > 0" style="
                        padding-left: 0px;
                        padding-right: 0px;
                        height: 445px;
                        overflow: scroll;
                      ">
                      <!-- Morining Slots -->
                      <div class="row" style="padding-left: 0px" id="morning" v-show="hasMorningSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sun-mor.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-left: 10px;
                            ">{{ $t("message.Morning") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isMorning(slot.start)" :class="
                              checkForAvailibility(
                                slot,
                                appointment.provider.providerId
                              )
                            ">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>

                      <!--Afternoon Slot -->
                      <div class="row" style="padding-left: 0px" id="after" v-show="hasAfternoonSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sun-noon.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-left: 10px;
                            ">{{ $t("message.Afternoon") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isAfternoon(slot.start)" :class="
                              checkForAvailibility(
                                slot,
                                appointment.provider.providerId
                              )
                            ">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>

                      <div class="row" style="padding-left: 0px" v-show="hasEveningSlots()">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/sunset.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-left: 10px;
                            ">{{ $t("message.Evening") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isEvening(slot.start)" :class="
                              checkForAvailibility(
                                slot,
                                appointment.provider.providerId
                              )
                            ">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>
                      <div class="row" style="padding-left: 0px" v-show="
                          hasNightSlots(appointment.provider.availableSlots)
                        ">
                        <div class="col-lg-2 mt-2">
                          <img src="@/assets/img/moon.png" style="width: 20px" />
                          <span translate style="
                              color: grey;
                              font-size: 0.9em;
                              padding-left: 10px;
                            ">{{ $t("message.Night") }}</span>
                        </div>
                        <div class="col-lg-10">
                          <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isNight(slot.start)" :class="
                              checkForAvailibility(
                                slot,
                                appointment.provider.providerId
                              )
                            ">{{ getFormattedTimeForView(slot.start) }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center" style="padding: 20px; width: 100%" v-show="slots.length < 1" v-loading="LOADING_SLOTS">
            <p class="alert-text" style="margin-bottom: 0px; font-size: large">
              <i>{{ $t("message.No slots available on this day") }}</i>
            </p>
          </div>
        </div>
      </div>

      <template slot="footer">
        <n-button type="danger" @click.native="SHOW_SCHEDULER = false" round>{{
          $t("message.Cancel")
        }}</n-button>
        <n-button @click.native="book()" type="primary" round>{{$t("message.Book Now") }}</n-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { TabPane, Tabs, Modal } from "src/components";
import { CoolSelect } from "vue-cool-select";

import socket from "@/services/socket";
import moment from "moment";
export default {
  name: "attend-request",

  components: {
    TabPane,
    Tabs,
    CoolSelect,
    Modal,
  },

  data() {
    return {
      simpleMeetingsQuery: null,
      patientDetails: null,
      filteredDoctorList: [],
      doctorSearchText: null,
      SHOW_SCHEDULER: false,
      searchedSpecialities: [],
      selectedSpeciality: null,

      //Scheduler
      slots: [],
      days: [],
      selectedDay: null,
      selectedDay: null,
      LOADING_SLOTS: false,
      selectedSlot: null,
      APPT_PROCESSED: false,
    };
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },

    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    appointment() {
      return this.$store.state.appointment;
    },
    patientAge() {
      var m = moment(this.patientDetails.dob);
      var years = moment().diff(m, "years", false);
      var months = moment().diff(m.add(years, "years"), "months", false);
      return (
        years +
        " " +
        this.$t("message.Years") +
        " " +
        months +
        " " +
        this.$t("message.Months")
      );
    },
  },

  async mounted() {
    let that = this;

    this.changeAppHeaderText("video-call");

    this.simpleMeetingsQuery = {
      api_key: this.settings.vMaatuSettings.apikey,
      room_name: this.instance + "_" + this.appointment._id,
      user_name: this.user.username,
      tenant_name: this.user.tenant.name,
      instance: this.instance,
    };

    setTimeout(() => {
      that.$refs.vmaatu.init();
    }, 1000);

    try {
      this.patientDetails = await this.$store.dispatch(
        "getPatientByPatientId",
        this.appointment.patient.patientId
      );
    } catch (e) {
      console.log(e);
    }

    socket.on("appointmentRequestCancelled", function (data) {
      swal
        .fire({
          type: "info",
          title: that.$t("message.Patient has cancelled the request"),
        })
        .then(() => {
          that.$router.push("carecohome");
        });
    });
  },

  beforeDestroy() {
    this.APPT_PROCESSED && this.leaveRoom();
    this.$refs.vmaatu.destroy();
    socket.off("appointmentRequestCancelled");
  },

  methods: {
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    async searchDoctor(searchString) {
      this.doctorSearchText = searchString;
      let query = {
        searchString,
      };
      if (
        this.settings &&
        this.settings.locationSensitivity &&
        this.user &&
        this.user.location
      ) {
        query.location = this.user.location;
      }
      if (
        this.settings &&
        this.settings.specialitySensitivity &&
        this.user &&
        this.user.speciality
      ) {
        query.speciality = JSON.stringify(
          this.user.speciality.map((speciality) => speciality._id)
        );
      }
      let response = await this.$store.dispatch("searchDoctors", query);
      this.filteredDoctorList = response.data;
    },
    async selectDoctor(doctor) {
      this.selectedSpeciality = null;

      this.$set(this.appointment, "provider", {
        providerId: doctor._id,
        username: doctor.users,
        firstName: doctor.firstName,
        lastName: doctor.lastName,
        fullName: doctor.firstName + " " + doctor.lastName,
        specialityText: doctor.specialityText,
      });

      try {
        let questionnaires = await this.$store.dispatch(
          "getProviderQuestionnaires",
          this.appointment.provider.providerId
        );

        this.appointment.questionnaires = questionnaires;
      } catch (e) {
        console.log(e);
      }
    },

    async searchSpecialities(searchString) {
      this.specialitySearchText = searchString;
      let response = await this.$store.dispatch(
        "searchSpecialities",
        searchString
      );
      this.searchedSpecialities = response.data;
    },
    async selectSpeciality(speciality) {
      this.appointment.provider = null;
      this.selectedSpeciality = speciality;
      this.appointment.specialityId = speciality._id;
    },

    async assign() {
      if (
        (this.appointment.provider || this.selectedSpeciality) &&
        this.appointment.reason &&
        this.appointment.priority
      ) {
        this.appointment.appointmentStatus.push({
          status: "Assigned",
          timestamp: new Date().getTime(),
        });

        this.appointment.latestStatus = "Assigned";

        try {
          await this.$store.dispatch("updateAppointment", this.appointment);
          this.APPT_PROCESSED = true;
          swal
            .fire({
              title: this.$t("message.Appointment assigned successfully"),
              confirmButtonText: this.$t("message.End call"),
              showCancelButton: true,
              cancelButtonText: this.$t("message.Stay"),
            })
            .then(async (result) => {
              if (result && result.value) {
                this.leaveRoom();
              }
            });
        } catch (e) {
          console.log(e);
        }
      } else {
        swal.fire({
          type: "warning",
          text: this.$t("message.Please fill in required details"),
        });
      }
    },

    //Scheduler
    async openScheduler() {
      if (
        (this.appointment.provider || this.selectedSpeciality) &&
        this.appointment.reason &&
        this.appointment.priority
      ) {
        this.SHOW_SCHEDULER = true;
        this.initDays();

        this.getSlots();
      } else {
        swal.fire({
          type: "warning",
          text: this.$t("message.Please fill in required details"),
        });
      }
    },
    initDays() {
      this.days = [
        {
          date: new Date(),
          formattedDate: moment(new Date()).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 1)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 1))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 2)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 2))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 3)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 3))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 4)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 4))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 5)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 5))
          ).format("ddd, Do MMM"),
        },
        {
          date: new Date(new Date().setDate(new Date().getDate() + 6)),
          formattedDate: moment(
            new Date(new Date().setDate(new Date().getDate() + 6))
          ).format("ddd, Do MMM"),
        },
      ];

      this.selectedDay = this.days[0];
    },
    getDay(day) {
      if (day.formattedDate == moment(new Date()).format("ddd, Do MMM")) {
        return "Today";
      } else {
        return day.formattedDate;
      }
    },
    hasMorningSlots() {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > -1 && hour < 12 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasAfternoonSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 11 && hour < 16 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasEveningSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 15 && hour < 20 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasNightSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 19 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    isMorning(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > -1 && hour < 12) {
        return true;
      } else {
        return false;
      }
    },
    isAfternoon(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 11 && hour < 16) {
        return true;
      } else {
        return false;
      }
    },
    isEvening(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 15 && hour < 20) {
        return true;
      } else {
        return false;
      }
    },
    isNight(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 19) {
        return true;
      } else {
        return false;
      }
    },
    checkForAvailibility(slot, userId) {
      var isFree = false;

      var user = slot.availability.users[userId];
      if (this.selectedSlot && this.selectedSlot.start == slot.start) {
        return "btn-info";
      } else if (user.appointments == "free") {
        return "btn-success";
      } else return "d-none";
    },
    getFormattedTimeForView(time) {
      return moment(time).format("h:mm A");
    },
    selectSlot(slot) {
      this.selectedSlot = slot;
    },
    async book() {
      this.appointment.scheduledTimestamp = {
        start: this.selectedSlot.start,
        end: this.selectedSlot.end,
      };

      try {
        let questionnaires = await this.$store.dispatch(
          "getProviderQuestionnaires",
          this.appointment.provider.providerId
        );

        this.appointment.questionnaire = {};
        this.appointment.attendant = {};
        this.appointment.questionnaires = questionnaires;
        this.appointment.attendant.firstName = this.user.firstName;
        this.appointment.attendant.lastName = this.user.lastName;
        this.appointment.attendant.username = this.user.username;
        this.appointment.appointmentStatus = [
          {
            status: "Created",
            timestamp: new Date().getTime(),
          },
        ];
        this.appointment.latestStatus = "Created";
        this.appointment.appointmentType = "Scheduled";

        if (this.appointment.patient.dob)
          this.appointment.patient.dob = moment.utc(
            this.appointment.patient.dob
          );

        var hexDateArray = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];

        //Create reference ID from patient's DOB and mongo document ID
        var day =
          hexDateArray[new Date(this.appointment.patient.dob).getDate()];
        var month = (new Date(this.appointment.patient.dob).getMonth() + 1)
          .toString(16)
          .toUpperCase();
        var year = new Date(this.appointment.patient.dob)
          .getFullYear()
          .toString()
          .substring(2);
        var id = this.appointment._id.toString().substring(20).toUpperCase();
        this.appointment.referenceId = day + month + year + id;

        await this.$store.dispatch("updateAppointment", this.appointment);
        this.SHOW_SCHEDULER = false;
        this.APPT_PROCESSED = true;

        swal
          .fire({
            title: this.$t("message.Appointment booked successfully"),
            confirmButtonText: this.$t("message.End call"),
            showCancelButton: true,
            cancelButtonText: this.$t("message.Stay"),
          })
          .then(async (result) => {
            if (result && result.value) {
              this.leaveRoom();
            }
          });
      } catch (e) {
        console.log(e);
      }
    },
    async leaveAppointment() {
      swal
        .fire({
          title: this.$t("message.Close Appointment?"),
          text: this.$t(
            "message.Are you sure that you want to cancel this request?"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, Close",
          cancelButtonText: "No",
          closeOnConfirm: true,
        })
        .then((result) => {
          // Leave room if appointment is processed or decline request
          result.value && this.appointment.latestStatus != "UnderReview"
            ? this.leaveRoom()
            : this.declineRequest(this.appointment);
        });
    },
    leaveRoom() {
      //Leave appointment room
      socket.emit("leaveRoom", {
        type: "appointment",
        id: this.appointment._id,
        userId: this.user._id,
      });

      //Sending update to patient
      socket.emit("appointmentReviewed", {
        patientId: this.patientDetails._id,
        appointmentId: this.appointment._id,
        specialityName: "",
        appointmentType: this.appointment.appointmentType,
      });

      //Sending update to doctor
      socket.emit("appointmentListUpdate", {
        providerId: this.appointment.provider.providerId,
      });

      //stopping spark video call
      if (this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED") {
        this.endWebexCall(this.appointment, true);
      }
      this.$router.push("carecohome");
    },

    async declineRequest(appointment) {
      try {
        await this.$store.dispatch("updateStatus", {
          appointmentId: appointment._id,
          status: "Declined",
        });

        socket.emit("appointmentDeclined", {
          appointmentId: appointment._id,
        });

        try {
          socket.emit("appointmentDeclined", {
            patientId: this.patientDetails._id,
            apptId: appointment._id,
          });
        } catch (e) {
          console.log(e);
        }

        this.$emit("appointment-declined");
        this.$router.push("carecohome");
      } catch (e) {
        console.log(e);
      }
    },

    getSlotsForNextDay() {
      if (this.days.indexOf(this.selectedDay) != this.days.length - 1) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) + 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    getSlotsForPreviousDay() {
      if (this.days.indexOf(this.selectedDay) != 0) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) - 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    async getSlots() {
      this.LOADING_SLOTS = true;
      let query = {
        type: "appointment",
        users: [this.appointment.provider.providerId],
        tenant: this.appointment.tenant,
        dateStart: this.selectedDay.date.setHours(0, 0, 0, 0),
        dateEnd: this.selectedDay.date.setHours(23, 59, 59, 0),
      };

      try {
        this.slots = await this.$store.dispatch("getAvailableSlots", query);
      } catch (e) {
        console.log(e);
      }
      this.LOADING_SLOTS = false;
    },
    selectDay(day) {
      this.selectedDay = day;
      this.getSlots();
    },
  },
};
</script>

<style scoped>
.slot-btn {
  width: 6em !important;
}
.not-available {
  cursor: no-drop;
  pointer-events: none;
}
/deep/ .el-loading-mask {
  background: #fffc !important;
  top: -15px;
}
/deep/ .el-loading-spinner {
  top: 10%;
}
/deep/ .tab-content {
  height: calc(100% - 68px);
  /* for fixed pagination from bottom */
  position: relative;
}
.content > div,
.content > div > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
